import { z } from 'zod';

import { OpsiumPolicy } from '@/modules/common/types/opsium-policy';

/**
 * Validation schema for a single permission row.
 * `groups` is a record because the set of user groups is dynamic — see `UserGroupFieldKey`.
 */
export const permissionRowSchema = z.object({
  policy: z.nativeEnum(OpsiumPolicy),
  groups: z.record(z.string(), z.boolean()),
});

/**
 * Validation schema for permissions form
 */
export const permissionsFormSchema = z.object({
  permissions: z.array(permissionRowSchema),
});

export type PermissionsFormDataValidated = z.infer<typeof permissionsFormSchema>;
